import * as SMLoggedInUserOfficeCodesActions from './../actions/SMloggedInUserOfficeCodes.actions';
import { AppState } from '../state/App.state';
import { SMLoggedInUserOfficeCodessModel } from '../models/SMloggedInUserDetails.model';

const initialState = {
    SMOfficeDetails: []
}

export function SMloggedInUserOfficeCodesDataReducer(state: SMLoggedInUserOfficeCodessModel = initialState, action: SMLoggedInUserOfficeCodesActions.Actions) {

    switch (action.type) {
        case SMLoggedInUserOfficeCodesActions.UPDATE_SM_LOGGEDIN_USER_OFFICE_CODES:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
}

export const selectSMLoggedInUserOfficeCodes = (state: AppState) => state.SMloggedinUserOfficeCodes;

